import React from 'react';
import ReactGA from 'react-ga';
import { useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';

import { RequestProvider } from '@common/react/components/RequestProvider/RequestProvider';

import AttentionMessagesWrapper from '@app/components/UI/AttentionMessage/AttentionMessagesWrapper';
import CookieBanner from '@app/components/UI/CookieBanner/CookieBanner';
import { SentryErrorBoundary } from '@app/components/UI/ErrorBoundary/SentryErrorBoundary';
import RequestWithTimeoutProvider from '@app/providers/RequestWithTimeoutProvider/RequestWithTimeoutProvider';
import { ApplicationState } from '@app/store';

const LayoutWrapper: React.FC = () => {
	const location = useLocation();
	const debug = useSelector((state: ApplicationState) => state.login.debug);

	const hiddenStyles: React.CSSProperties = {
		display: 'none',
		visibility: 'hidden',
	};

	React.useEffect(() => {
		if (!debug) {
			ReactGA.initialize('UA-26388509-1');
		}
	}, [debug]);

	React.useEffect(() => {
		ReactGA.pageview(location.pathname + location.search);
	}, [location.pathname, location.search]);

	return (
		<SentryErrorBoundary>
			<RequestProvider>
				<RequestWithTimeoutProvider>
					<noscript>
						<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-53KG2QP" height="0" width="0" style={hiddenStyles} title="ns.html?id=GTM-53KG2QP" />
					</noscript>
					<Outlet />
					<CookieBanner />
					<AttentionMessagesWrapper />
				</RequestWithTimeoutProvider>
			</RequestProvider>
		</SentryErrorBoundary>
	);
};
export default LayoutWrapper;
